import { render, staticRenderFns } from "./AxRelayPortSelectDialog.vue?vue&type=template&id=30b84ca4&scoped=true"
import script from "./AxRelayPortSelectDialog.vue?vue&type=script&lang=ts"
export * from "./AxRelayPortSelectDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxRelayPortSelectDialog.vue?vue&type=style&index=0&id=30b84ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b84ca4",
  null
  
)

export default component.exports